import { TimezoneService } from './../../services/timezone.service';
import { OrderFormSection } from './../../../core/classes/orderFieldConfig';
import { SectionName, PropertyName } from './../../../core/enumerations/sectionNames';
import { Constants } from 'src/app/shared/constants';
import { DynamicFormServiceService } from '../../services/dynamic-form-service.service';
import { AfterViewChecked, Component, OnInit, Renderer2, ViewChild, HostListener } from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormArray,AbstractControl,ValidationErrors,ValidatorFn} from '@angular/forms';
import { DynamicForm } from '../../error-messages';
import { OrderFieldConfig } from 'src/app/core/classes/orderFieldConfig';
import moment from 'moment-timezone';
import { ThemePalette } from '@angular/material/core';


@Component({
    selector: 'app-order-date-time-picker-form',
    templateUrl: './order-date-time-picker-form.component.html',
    styleUrls: ['./order-date-time-picker-form.component.scss'],
    standalone: false
})
export class OrderDateTimePickerFormComponent implements OnInit, AfterViewChecked {

  @ViewChild('picker') picker: any;
  field: OrderFieldConfig;
  group: UntypedFormGroup;
  groups: UntypedFormArray;
  parentOrderForm: UntypedFormGroup;
  isRequired: boolean;
  currentMax = ['USDATE', 'BPDATE', 'MDOB'];
  currentDate = new Date().toDateString();
  controlIndexMaxDate: number;
  controlIndexMinDate: number;
  labelCodeValidator: string;
  timeZoneValue: string;
  timeZoneOffSet: any;
  accountPreferences: OrderFormSection[] = [];
  required = Constants.IS_REQUIRED;
  public enableMeridian = true;
  showSpinners = true;
  maxDate: any;
  minDate: any;
  isDisabled = false;
  public color: ThemePalette = 'primary';
  ValidationMessages = {
    invalidDateFormat: DynamicForm.INVALID_DATE_FORMAT,
    dateValidation: DynamicForm.ENTER_VALID,
  };
  hideRequiredMarker=true;
  datepickerValidationMsg = {
    requiredError: 'Date and Time is mandatory.',
    timeNotinFutureMessage: 'Date and Time cannot be in the future.',
    invalidDateFormat: 'Please enter date in MM/DD/YYYY hh:mm A format',
    minDateError: 'Date and time entered cannot be less than the minimum date.'
  };
  orderInformationSectionForm: UntypedFormArray;
  defaultTime: any;
  isFocused = false;
  
  @HostListener('window:keydown', ['$event'])
  handleGlobalKeydown(event: KeyboardEvent) {
    if (this.isFocused) {
      this.onKeydown(event);
    }
  }
  constructor(private dynamicService: DynamicFormServiceService,
              private timeZoneService: TimezoneService,
              private renderer: Renderer2) { }

  ngOnInit() {
    this.field.minDateTimeError = false;
    this.field.maxDateTimeError = false;
    if (this.currentMax.includes(this.field.labelCode)) {
      this.field.maxDate = new Date(this.currentDate);
    } else if (this.field.labelCode === 'EDD') {
      this.field.minDate = new Date(this.currentDate);
      this.field.maxDate = new Date(moment(this.currentDate).add(1, 'years').toDate().toDateString());
    }
    this.isRequired = this.dynamicService.checkHasRequired(this.field);
    
    
    this.getTimeZoneValue();
    this.setMaxAndMinDate();
    this.setValidationsOnValueChanges();
    this.getMinAndMaxErrors();
  }

  ngAfterViewChecked(): void {
    document.getElementById(this.field.labelName) === document.activeElement ? this.isFocused = true : this.isFocused = false;
  }

  onKeydown(zEvent) {
    if ((zEvent.key === 't' || zEvent.key === 'T')) {
      zEvent.preventDefault();
      (window as any).isPressedT = true;
      this.group.get(this.field.labelCode).setValue(moment(this.getDefaultDateWithOffset(0)));
    } else if ((zEvent.key === 'y' || zEvent.key === 'Y')) {
      zEvent.preventDefault();
      (window as any).isPressedT = true;
      this.group.get(this.field.labelCode).setValue(moment(this.getDefaultDateWithOffset(-1)));
    } else {
      (window as any).isPressedT = false;
    }
  }
  
  private getDefaultDateWithOffset(daysOffset: number): Date {
    const base = new Date();
    if (daysOffset !== 0) {
      base.setDate(base.getDate() + daysOffset);
    }
    const tzDate = this.convertDateToTimeZoneSelected(base);
    if (this.defaultTime && Array.isArray(this.defaultTime) && this.defaultTime.length >= 2) {
      tzDate.setHours(this.defaultTime[0], this.defaultTime[1], 0, 0);
    }
    return tzDate;
  }

  setMaxAndMinDate() {
    this.field.validations.forEach(x => {
      this.setMinAndMaxForLabelCodeValidators(x);
      this.setMinAndMaxForCurrentDates(x);
    });
    this.disableFields();
  }

  setMinAndMaxForLabelCodeValidators(x) {
    if (x.name === Constants.MAX_DATE) {
      if (x.validator !== Constants.CURRENT_DATE && !this.isDate(new Date(x.validator))) {
        this.labelCodeValidator = x.validator;
        this.controlIndexMaxDate = this.groups.controls.findIndex(p => (p as UntypedFormGroup).get(x.validator));
        this.field.maxDate = (this.controlIndexMaxDate > -1) ?
          this.groups.controls[this.controlIndexMaxDate].value[this.labelCodeValidator] : null;
        this.field.originalMaxDate = this.field.maxDate;
      }
    } else if (x.name === Constants.MIN_DATE) {
      if (x.validator !== Constants.CURRENT_DATE && !this.isDate(new Date(x.validator))) {
        this.labelCodeValidator = x.validator;
        this.controlIndexMinDate = this.groups.controls.findIndex(p => (p as UntypedFormGroup).get(x.validator));
        this.field.minDate = (this.controlIndexMinDate > -1) ?
          this.groups.controls[this.controlIndexMinDate].value[this.labelCodeValidator] : null;
        this.field.originalMinDate = this.field.minDate;
      }
    }
  }

  setMinAndMaxForCurrentDates(x) {
    if (x.validator === Constants.CURRENT_DATE) {
      x.name === Constants.MAX_DATE ? this.field.maxDate = new Date(this.convertDateToTimeZoneSelected(new Date()))
        : this.field.minDate = new Date(this.convertDateToTimeZoneSelected(new Date()));
      x.name === Constants.MAX_DATE ? this.field.originalMaxDate = new Date() :
        this.field.originalMinDate = new Date();
    }
    if (this.isDate(new Date(x.validator))) {
      x.name === Constants.MAX_DATE ? this.field.maxDate = new Date(this.convertDateToTimeZoneSelected(new Date(x.validator)))
        : this.field.minDate = new Date(this.convertDateToTimeZoneSelected(new Date(x.validator)));
      x.name === Constants.MAX_DATE ? this.field.originalMaxDate = new Date(x.validator) :
        this.field.originalMinDate = new Date(x.validator);
    }
  }

  setValidationsOnValueChanges() {
    if (this.controlIndexMaxDate > -1) {
      this.groups.controls[this.controlIndexMaxDate].valueChanges.subscribe(x => {
        this.field.maxDate = this.groups.controls[this.controlIndexMaxDate].value[this.labelCodeValidator];
        this.disableFields();
      });
    } else if (this.controlIndexMinDate > -1) {
      this.groups.controls[this.controlIndexMinDate].valueChanges.subscribe(x => {
        this.field.minDate = this.groups.controls[this.controlIndexMinDate].value[this.labelCodeValidator];
        this.disableFields();
      });
    }
    this.orderInformationSectionForm = this.parentOrderForm.get(SectionName.ORDER_INFROMATION) as UntypedFormArray;
    const index = (this.orderInformationSectionForm) ? (this.parentOrderForm.get(SectionName.ORDER_INFROMATION) as UntypedFormArray)
      .controls.findIndex(p => (p as UntypedFormGroup).get(PropertyName.TimeZone)) : -1;
    if (index > -1) {
      (this.parentOrderForm.get(SectionName.ORDER_INFROMATION) as UntypedFormArray).controls[index].valueChanges.subscribe(x => {
        const TimeZone = this.orderInformationSectionForm.controls[index].value[PropertyName.TimeZone];
          this.timeZoneValue = TimeZone;
        this.setDefaultTime();
        this.field.validations.forEach(x => {
          this.setMinAndMaxForCurrentDates(x);
        });
        setTimeout(() => {
          this.field.maxDate = this.field.originalMaxDate ? new Date(this.convertDateToTimeZoneSelected(this.field.originalMaxDate)) : null;
          this.field.minDate = this.field.originalMinDate ? new Date(this.convertDateToTimeZoneSelected(this.field.originalMinDate)) : null;
        }, 200);
      });
    }
  }

  isDate(date) {
    return moment(date, moment.ISO_8601, true).isValid();
  }

  setDefaultTime() {
    const currentTime = new Date(this.convertDateToTimeZoneSelected(new Date()));
    const hours = currentTime.getHours();
    const minutes = currentTime.getMinutes();
    const defaultTime: number[] = [];
    defaultTime.push(hours, minutes);
    this.defaultTime = defaultTime;
  }

  getTimeZoneValue() {
    const orderInformationSectionValues = this.parentOrderForm.getRawValue()[SectionName.ORDER_INFROMATION];
    let value = '';
    if (Array.isArray(orderInformationSectionValues)) {
      orderInformationSectionValues.forEach(element => {
        const temp = element[PropertyName.TimeZone];
        if (temp) {
          value = temp;
          this.timeZoneValue = value;
        }
      });
    }
    this.setDefaultTime();
    return value;
  }

  convertDateToTimeZoneSelected(date) {
    const currentTimeZoneName = this.timeZoneService.getTimezoneName();
    const orderSectionPreferences = this.accountPreferences.find(p => p.sectionName === SectionName.ORDER_INFROMATION)?.values;
    if (!orderSectionPreferences) { return new Date(date); }

    const rawOffset = orderSectionPreferences.find(p => p.labelCode === PropertyName.TimeZone)?.options
      .find(t => t.value === this.timeZoneValue)?.timeZoneOffset;
    const offsetMinutes = Number(rawOffset);
    if (!Number.isFinite(offsetMinutes)) { return new Date(date); }

    // If timezone equals local or not selected, return original
    if (this.timeZoneValue === currentTimeZoneName || !this.timeZoneValue) { return new Date(date); }

    const m = moment.utc(date).utcOffset(offsetMinutes);
    return new Date(m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond());
  }

  disableFields() {
    if (this.labelCodeValidator &&
      !((this.groups.controls[this.controlIndexMinDate] && this.groups.controls[this.controlIndexMinDate].value[this.labelCodeValidator])
        || (this.groups.controls[this.controlIndexMaxDate]
          && this.groups.controls[this.controlIndexMaxDate].value[this.labelCodeValidator]))) {
      this.group.get(this.field.labelCode).disable();
      this.isDisabled = true;
    } else {
      this.group.get(this.field.labelCode).enable();
      this.isDisabled = false;
    }
  }

  getMinAndMaxErrors() {
    this.group.get(this.field.labelCode).valueChanges.subscribe(() => {
      const errs = this.group.get(this.field.labelCode).errors || {};
      this.field.maxDateTimeError = !!(errs.matDatetimePickerMax || errs.owlDateTimeMax || errs.matDatepickerMax || errs.max);
      this.field.minDateTimeError = !!(errs.matDatetimePickerMin || errs.owlDateTimeMin || errs.matDatepickerMin || errs.min);
      this.field.dateFormatError = !!(errs.matDatetimePickerParse || errs.owlDateTimeParse || errs.matDatepickerParse || errs.parse);
    });
  }

  resetDefaultTime() {
    this.setDefaultTime();
    this.field.validations.forEach(x => {
      this.setMinAndMaxForLabelCodeValidators(x);
      this.setMinAndMaxForCurrentDates(x);
    });
    setTimeout(() => {
      this.field.maxDate = this.field.originalMaxDate ? new Date(this.convertDateToTimeZoneSelected(this.field.originalMaxDate)) : null;
    }, 200);
  }

    private getInitialPickerMoment(): Date {
  const rawValue = this.group.get(this.field.labelCode)?.value;
  const parsedValue = rawValue instanceof Date ? rawValue : rawValue ? new Date(rawValue) : null;
  const baseDate =
    parsedValue && !isNaN(parsedValue.getTime())
      ? new Date(this.convertDateToTimeZoneSelected(parsedValue))
      : new Date(this.convertDateToTimeZoneSelected(new Date()));
  baseDate.setSeconds(0, 0);
  const min = this.field.minDate ? new Date(this.field.minDate) : null;
  const max = this.field.maxDate ? new Date(this.field.maxDate) : null;
  if (min && baseDate < min) { return new Date(min); }
  if (max && baseDate > max) {return new Date(max); }
  return baseDate;
}

  onPickerOpen(picker: any): void {
    if (!picker) { return; }
    const momentValue = moment(this.getInitialPickerMoment());
    try {
      picker.select(momentValue);
    } catch { /* defensive: library internals may differ */ }

    const container = picker.pickerContainer;
    if (container) {
      try {
        // Refresh the calendar viewport and timer display to match.
        container.pickerMoment = momentValue;
      } catch { /* defensive */ }
    }
  }
}
